import React, { memo } from 'react'

import { Box, Drawer, IconButton } from '@material-ui/core'
import DoubleArrowRoundedIcon from '@material-ui/icons/DoubleArrowRounded'
import { ReactSVG } from 'react-svg'

import useAuth from '~/utils/auth/useAuth'

import useStyles from './style'

interface Props {
  children: React.ReactNode
  handleDrawer: () => void
  open: boolean
}

const DesktopSidebar = ({ children, handleDrawer, open }: Props) => {
  const classes = useStyles({ open })
  const { userData } = useAuth()

  const orgCode =
    userData?.userOrg?.parentOrgCode.toLowerCase() ||
    userData?.userOrg?.orgCode.toLowerCase()

  const LOGO_ORG_CODE = () => ({
    fleeto: (
      <ReactSVG
        className={classes.logo}
        src="/public/brands/logo-fleeto-white.svg"
      />
    ),
    kalista: (
      <img
        className={classes.logoKalista}
        src="/public/brands/logo-kalista.png"
      />
    ),
    alva: (
      <img className={classes.logoAlva} src="/public/brands/alva-logo.webp" />
    ),
    emiev: (
      <img className={classes.logoAlva} src="/public/brands/alva-logo.webp" />
    ),
    xl: (
      <img className={classes.logo} src="/public/brands/xl-smart-white.svg" />
    ),
    xlaxiata: (
      <img className={classes.logo} src="/public/brands/xl-smart-white.svg" />
    ),
    tricon: (
      <img
        className={classes.logoTricon}
        src="/public/brands/tricon-logo.png"
      />
    ),
  })

  return (
    <Box className="hide-on-mobile">
      <Drawer
        variant="permanent"
        open={open}
        className={classes.drawer}
        classes={{ paper: classes.drawerPaper }}
      >
        <div className={classes.drawerHead}>
          <Box hidden={!open}>
            {LOGO_ORG_CODE()[orgCode] || (
              <ReactSVG
                className={classes.logo}
                src="/public/brands/logo-fleeto-white.svg"
              />
            )}
          </Box>
          <IconButton className={classes.expandButton} onClick={handleDrawer}>
            {open ? (
              <DoubleArrowRoundedIcon className={classes.iconClose} />
            ) : (
              <DoubleArrowRoundedIcon />
            )}
          </IconButton>
        </div>
        {children}
      </Drawer>
    </Box>
  )
}

export default memo(DesktopSidebar)
